module.exports = function(bootstrap) {

    'use strict';
    bootstrap.directive('vbid', ["$q", "teamsite", function($q, teamsite) {

        return {
            restrict: 'A',
            replace: false,
            template: require('./vbidIcon.html'),
            scope: {
                vbid: '=vbid'
            },
            controller: ['$scope', 'modal', '$state',  function($scope, modal,$state) {

                $scope.vbidInd = $scope.vbid.vbidIndicator;
                $scope.currentDate = $scope.vbid.formDate;
                $scope.effectiveDate = $scope.vbid.vbidEffDate;
                $scope.terminationDate = $scope.vbid.vbidTerDate;
                $scope.eDate = $scope.vbid.vbidEffectiveDate;
                $scope.tDate = $scope.vbid.vbidTerminationDate;

                $scope.VBID="<span>A Preferred Provider in the Blue Care Advantage Program. </span><span><a style='color:#0071a9' data-ng-click='$parent.goToMore()'>See More</a></span>";

                $scope.goToMore = function() {
                    $state.go("vbid");
                };
            }]
        };
    }]);
};


